import { useTheme } from '@mui/material/styles';
export const useEditUserResponseDialogStyles = () => {
    const theme = useTheme();
    return {
        dialogContentStyle: {
            maxHeight: '70vh',
            overflow: 'auto'
        },
        contentBoxStyle: (isHighlighted) => ({
            border: `1px solid ${isHighlighted ? theme.palette.primary.main : theme.palette.grey[300]}`,
            borderRadius: '12px',
            padding: theme.spacing(2),
            backgroundColor: isHighlighted ? theme.palette.primary.light + '08' : theme.palette.grey[50],
            transition: 'all 0.3s ease',
            '&:hover': {
                borderColor: theme.palette.primary.main,
                backgroundColor: theme.palette.primary.light + '12'
            }
        }),
        sectionTitleStyle: {
            color: theme.palette.text.primary,
            fontWeight: 600,
            marginBottom: theme.spacing(1)
        },
        fieldLabelStyle: {
            color: theme.palette.text.secondary,
            fontWeight: 500,
            fontSize: '0.875rem',
            marginBottom: theme.spacing(0.5)
        },
        fieldValueStyle: {
            color: theme.palette.text.primary,
            fontWeight: 400
        },
        iconStyle: {
            color: theme.palette.primary.main,
            fontSize: '20px'
        },
        mobileDrawerStyle: {
            borderTopLeftRadius: '24px',
            borderTopRightRadius: '24px',
            maxHeight: '85vh',
            minHeight: '50vh'
        },
        appBarStyle: {
            backgroundColor: theme.palette.background.paper,
            borderBottom: `1px solid ${theme.palette.divider}`
        },
        mobileToolbarStyle: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: theme.spacing(1, 2)
        },
        footerBoxStyle: {
            padding: theme.spacing(2),
            borderTop: `1px solid ${theme.palette.divider}`,
            backgroundColor: theme.palette.background.paper,
            display: 'flex',
            gap: theme.spacing(1)
        },
        dividerStyle: {
            margin: theme.spacing(2, 0),
            borderColor: theme.palette.divider
        },
        actionButtonStyle: {
            borderRadius: '8px',
            textTransform: 'none',
            fontWeight: 600,
            padding: theme.spacing(1, 3)
        }
    };
};
